// @import dependencies
import React, { CSSProperties, useEffect } from 'react'
// @end dependencies

// @import components
import { Form } from 'react-bootstrap';
// @end components

// @import types
import { TypeMaterialDelivery } from 'app_types/admin/courseScheduling/courseSchedulingTypes';
// @end types

// @import services
// @end services

// @import hooks
import { FieldValues, UseFormMethods } from 'react-hook-form';
// @end hooks

// @import actions
// @end actions

// @import utils
// @end utils

// @import assets
// @end assets

// @import styles
import { useTranslation } from 'react-i18next';
// @end styles

interface ICourseSchedulingModuleLayoutMaterialDeliveryProps {
  formHook: UseFormMethods<FieldValues>
  editData?: any
  className?: string
  style?: CSSProperties
  id?: string
}


const CourseSchedulingModuleLayoutMaterialDelivery: React.FC<ICourseSchedulingModuleLayoutMaterialDeliveryProps> = (props) => {

  const { t } = useTranslation();
  const materialState: TypeMaterialDelivery = props.formHook.watch('material_delivery');

  useEffect(() => {
    return () => {
      props.formHook.unregister('material_delivery');
      props.formHook.unregister('material_address');
    }
  }, []);

  return(
    <div
      className={`course_shceduling_module_layout_material_delivery-layout ${props.className ? props.className : ''}`}
      style={props.style}
      id={props.id}
    >
      <div className="d-flex align-items-center mb-2">
        <h3 className="form-title">{t("modules.course_scheduling.material_delivery")}</h3>
      </div>
      <div className="col-md-12">
        <Form.Group>
          <Form.Label>{t('labels.material_delivery.material_delivery')}</Form.Label>
          <Form.Control
            as="select"
            id="material_delivery"
            name='material_delivery'
            className={`${props.formHook.errors.material_delivery && 'is-invalid'}`}
            ref={props.formHook.register()}
            defaultValue={(props?.editData?.material_delivery) ? props?.editData?.material_delivery : 'digital'}
          >
            <option value='digital' >Digital</option>
            <option value='physic' >En físico</option>
            <option value='none' >No entrega</option>
          </Form.Control>
        </Form.Group>
      </div>
      {materialState === 'physic' ?
      <>
        <div className="col-md-12">
          <div className="form-group">
            <label htmlFor='material_address'>{t('labels.material_delivery.material_address')}</label>
            {props.formHook.errors.material_address && <div className='invalid-feedback'>{t('errors.this_field_is_required')}</div>}
            <input
              id='material_address'
              name='material_address'
              className={`form-control ${props.formHook.errors.material_address && 'is-invalid'}`}
              type='text'
              ref={props.formHook.register()}
              defaultValue={(props?.editData?.material_address) ? props?.editData?.material_address : ''}
            />
          </div>
        </div>
      </>
      :null}
    </div>
  );
}

export default CourseSchedulingModuleLayoutMaterialDelivery;
